import api from 'lib/trpcClient';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';

function useSoftDeleteAdvisedApplication() {
  return api.incompleteInvestment.softDelete.useMutation(
    useHandleTrpcMutation()({
      successMessage: 'Application deleted successfully.',
    }),
  );
}

export default useSoftDeleteAdvisedApplication;
